import useApiRequest from 'api/useApiRequest';
import { requestCustomSource } from 'api/services/feedService';

const useFeed = () => {
  const { request } = useApiRequest();

  const sendCustomSourceRequest = async (params: { signal?: AbortSignal; sourceName: string; url: string }) => {
    const { data } = await requestCustomSource(request, params);
    return data;
  };

  return { sendCustomSourceRequest };
};

export default useFeed;
